// Styles for scrollable text content in Pill component
import { createUseStyles } from 'react-jss'
import { darkGrey } from '../../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  pill: {
    fontSize: '12px',
    fontWeight: 400,
    textAlign: 'center',
    color: ({ fillText }) => fillText,
    maxHeight: '60px',
    overflowY: 'auto',
    overflowX: 'hidden',
    pointerEvents: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: `${darkGrey} transparent`
  }
})

export default useStyles
